const replaceEmptyStringsWithZeros = (obj: any): any => {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  if ('from' in obj && 'to' in obj) {
    return {
      ...obj,
      from: obj.from === '' ? 0 : obj.from,
      to: obj.to === '' ? 0 : obj.to,
    }
  }

  const result: any = Array.isArray(obj) ? [] : {}

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[key] = replaceEmptyStringsWithZeros(obj[key])
    }
  }

  return result
}

export default replaceEmptyStringsWithZeros